export interface GitModule {
  name: string;
  path: string;
}
